import axios from 'axios'
import qs from 'qs'

// export const HOST='http://127.0.0.1:9000/';
export const HOST='http://gmapi.kekodmc.com/';

const req = axios.create({
    baseURL:HOST,
    timeout:30000,
    responseType:'json'
});

req.interceptors.request.use(
    config=>{
        return config;
    },err=>{
        console.log('request:err',err)
    }
);

req.interceptors.response.use(
    res=>{
        if(res.status===200){
            return res.data
        }else{
            console.log('response fail')
        }
    },err=>{
        console.log('response:err',err)
    }
);

export default req

// get请求
export function get(url,params) {
    let data={
        url:url,
        params:params
    };
    return new Promise((resolve,reject)=>{
        req(data).then(res=>{
            switch (res.code) {
                case 200:
                    resolve(res)
                    break;
                default:
                    reject(res)
            }
        })
    })
}
//post 讲求
export function post(url,params) {
    let data={
        url:url,
        data:params
    };
    data.transformRequest=[function () {
        return qs.stringify(params)
    }]
    return new Promise((resolve,reject)=>{
        req(data).then(res=>{
            switch (res.code) {
                case 200:
                    resolve(res)
                    break;
                default:
                    reject(res)
            }
        })
    })
}